export enum ActionItemsContext {
  me = 'me',
  team = 'team',
  teamWithPagination = 'team_with_pagination',
  assignedTo = 'assigned_to',
}
